const audioContext = new (window.AudioContext || window.webkitAudioContext)()

export default audioContext



// WEBPACK FOOTER //
// ./src/modules/simon-game/api/audio-context.js